import { getRemotes } from './contract/api'

const getenvironment = async () => {
  const r = await getRemotes()

  window.PORTAL_URL = r.PORTAL_URL
  window.SCENARIOS_URL = r.SCENARIOS_URL
  window.PROJECTS_URL = r.PROJECTS_URL
  window.JOBS_URL = r.JOBS_URL
  window.DATASETS_URL = r.DATASETS_URL
  window.MAP_URL = r.MAP_URL
  window.REPORTS_URL = r.REPORTS_URL
  window.APP_FRAME_URL = r.APP_FRAME_URL
  window.STYLE_URL = r.STYLE_URL

  import('./bootstrap')
}

getenvironment()
